export let productCenterRobotEN = {
  title: "PD Robotics Virtual Development \n& Validation Solution",
  subtitle: `Robot "brain" optimization and validation based on multi-rigid-body structural dynamics`,
  features: [
    {
      title: `Solutions for the Application and Commercialization of Embodied Intelligence "Brain"`,
    },
    {
      title:
        "High Physical-Level Scenario and Feature Restoration for Specific Usecases",
    },
    {
      title: "High-Validity Perception Simulation Based on PlenRay Technology",
    },
    {
      title:
        "Accelerating Embodied Intelligence Implementation and Commercialization in Concrete Usecases",
      description: [
        "Hazardous Operations: Mining, unmanned paint spraying, welding, etc",
        "Warehousing & Unmanned Logistics: Dynamic storing, ware sorting, etc",
        "Catering & Commercial Services: Smart food delivering, shopping guiding, etc",
        "Medical Rehabilitation: Assistive robots, hospital logistics, etc",
        "Special & Emergency Scenarios: Underwater construction, fire rescue, self-maintenance systems, etc",
      ],
    },
  ],
};
export let productCenterRobotCN = {
  title: "PD 机器人虚拟开发\n验证解决方案",
  subtitle: "基于多刚体结构力学的机器人技术优化与测试",
  features: [
    {
      title: "面向具身智能“大脑”应用的解决方案",
    },
    {
      title: "面向具体落地场景的高物理级场景和场景特征还原",
    },
    {
      title: "结合PlenRay的高逼真度感知结果仿真",
    },
    {
      title: "帮助具身智能快速落地具体应用场景",
      description: [
        "危险环境作业： 矿山、 喷涂/焊接无人化等",
        "仓储与无人物流：动态仓储、商超分拣等",
        "餐饮与商业服务：智能送餐、零售导购等",
        "医疗康复：辅助机器人、医院物流等",
        "特种与应急场景：水下施工、火灾救援、自维护系统等",
      ],
    },
  ],
};
